






import { Component, Vue } from 'vue-property-decorator';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';

@Component
export default class BackButton extends Vue {
    constructor() {
        super();
    }

    get currentView() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    public goBack() {
        switch (this.currentView.view) {
            case Views.Messages:
                this.handleAction();
                break;

            case Views.Profile:
                this.handleAction();
                break;

            case Views.Options:
                this.handleAction();
                break;
        }
    }

    private handleAction() {
        switch (this.currentView.viewMode) {
            case ViewModes.Messages.Participants:
            case ViewModes.Messages.AddPerson:
                this.$store.commit(Mutations.SET_MESSAGES_VIEW_MODE, ViewModes.Messages.Messages);
                break;

            case ViewModes.Messages.Messages:
                this.$store.commit(Mutations.SET_MESSAGES_VIEW_MODE, ViewModes.Messages.Conversations);
                break;


            case ViewModes.Profile.EditProfile:
                this.$store.commit(Mutations.SET_VIEW, {
                    view: Views.Profile,
                    viewMode: ViewModes.Profile.Profile,
                    });
                break;
            case ViewModes.Profile.Profile:
                this.$router.go(-1); 
                break;

            case ViewModes.Options.YourOptionsView:
                this.$store.commit(Mutations.SET_VIEW, {
                    view: Views.Options,
                    viewMode: ViewModes.Options.All,
                    });
                break;
        }
    }
}
